import { Box, styled } from '@mui/material';

export const MainContainer = styled(Box)(({ theme }) => ({
  flexGrow: 1,
  minWidth: 0,
  marginTop: '60px',
  minHeight: '95vh',
  backgroundColor: theme.palette.background.default,
  overflowX: 'clip'
}));

export const LayoutContainer = {
  display: 'flex',
};

export const LoaderContainer = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  height: '90vh',
  width: '100%',
}));
